<script>
import APIPayment from '@app/services/API/Payment';

export default {
  data: () => ({
    quantity: {
      PACK_S: 1,
      PACK_M: 1,
      PACK_L: 1,
    },
  }),
  methods: {
    buy(price, quantity = 1) {
      const loader = this.$buefy.loading.open();
      APIPayment.getPaymentLink({ stripe_price_id: price, quantity })
        .then(({ data }) => (window.location.href = data.link))
        .catch((error) => {
          this.$errorHandlers.axios(error);
          // because location.href takes time
          loader.close();
        });
    },
  },
};
</script>

<template>
  <section class="aicbcomp pt-10 pb-10 mnh-full flex-center-center-column has-background-gradient-dark">
    <b-button
      class="aicbcomp_close"
      type="is-white"
      outlined
      icon-left="times"
      aria-label="Fermer"
      @click="$emit('close')"
    />

    <h1 class="title has-text-centered has-text-white">
      Travaillez plus vite (et plus sereinement)
      <br>
      grâce aux assistants IA Teachizy
    </h1>
    <div class="content is-medium mw-640 has-text-centered has-text-white">
      <p>
        Générez et améliorez des contenus de formation,
        des pages de vente et bien plus encore
        <strong class="has-text-white">en quelques clics.</strong>
      </p>
      <p>
        Nos
        <b-tooltip label="Propulsé par l'intelligence artificielle" dashed>
          outils IA
        </b-tooltip>
        vous accompagnent au quotidien pour <strong class="has-text-white">gagner un temps précieux</strong>
        et créer des formations engageantes… et rentables.
      </p>
    </div>

    <div class="columns is-multiline flex-none w-full mw-widescreen mt-10">
      <div class="column is-4">
        <div class="aicbcomp_card">
          <figure class="image aicbcomp_scribble aicbcomp_scribble--left">
            <img
              src="@app/assets/img/scribbles/cyan_five_petal_flower_large_eyes.png"
              alt="Forfait Découverte"
            >
          </figure>
          <article class="box is-white content">
            <header class="flex-between-center">
              <h2 class="title is-5 has-text-black mb-2">
                {{ $constants.AI_PRICES.CREDITS.PACK_S }} crédits
              </h2>
            </header>
            <p>
              <span class="is-size-2 has-text-weight-bold has-text-success">
                {{ $constants.AI_PRICES.PROMO.PACK_S }}&euro;
              </span>
              <span class="is-block is-size-8 has-text-grey-dark">
                Un seul paiement. Tarifs TTC.
              </span>
            </p>
            <p>
              Idéal pour découvrir nos assistants IA
              et faire vos premiers tests en toute simplicité.
            </p>
            <hr>
            <p class="has-text-weight-bold">
              Accédez à tous les outils :
            </p>
            <ul class="is-size-8">
              <li>Page de vente (rédaction complète)</li>
              <li>Structure pédagogique</li>
              <li>Contenus pédagogiques (générer des leçons multi-média)</li>
              <li>Titres & accroches</li>
              <li>Descriptions optimisées</li>
            </ul>
            <p>
              <b-icon icon="bolt" size="is-small" type="is-warning" />
              Résultats en moins de 5 minutes
            </p>
            <p class="is-flex">
              <b-dropdown class="mr-3" position="is-top-right">
                <template #trigger>
                  <b-button class="py-6 px-5">
                    {{ quantity.PACK_S }}
                  </b-button>
                </template>
                <b-dropdown-item class="w-280" custom>
                  <b-numberinput
                    type="is-white"
                    min="1"
                    max="10"
                    expanded
                    v-model="quantity.PACK_S"
                  />
                </b-dropdown-item>
              </b-dropdown>
              <b-button
                class="py-6"
                expanded
                @click="buy($constants.AI_PRICE_IDS.PACK_S, quantity.PACK_S)"
              >
                Acheter {{ $constants.AI_PRICES.CREDITS.PACK_S * quantity.PACK_S }} crédits
              </b-button>
            </p>
          </article>
        </div>
      </div>
      <div class="column is-4">
        <div class="aicbcomp_card">
          <figure class="image aicbcomp_scribble aicbcomp_scribble--center">
            <img
              src="@app/assets/img/scribbles/cyan_star_cute_face.png"
              alt="Pack Populaire"
            >
          </figure>
          <article class="box is-warning content">
            <span class="aicbcomp_badge tag is-warning is-medium">
              Le + populaire
            </span>
            <header class="flex-between-center">
              <h2 class="title is-5 has-text-black mb-2">
                {{ $constants.AI_PRICES.CREDITS.PACK_M }} crédits

                <span class="is-size-7 has-text-success">
                  + {{ $constants.AI_PRICES.GIFT.PACK_M }} offerts
                </span>
              </h2>
            </header>
            <p>
              <span class="is-size-2 has-text-weight-bold has-text-warning">
                {{ $constants.AI_PRICES.PROMO.PACK_M }}&euro;
              </span>
              <span class="is-block is-size-8 has-text-grey-dark">
                Un seul paiement. Tarifs TTC.
              </span>
            </p>
            <p>
              Le choix parfait pour reprendre et améliorer les contenus
              (vente & pédagogie) de vos formations en ligne.
            </p>
            <hr>
            <p class="has-text-weight-bold">
              Accédez à tous les outils :
            </p>
            <ul class="is-size-8">
              <li>Page de vente (rédaction complète)</li>
              <li>Structure pédagogique</li>
              <li>Contenus pédagogiques (générer des leçons multi-média)</li>
              <li>Titres & accroches</li>
              <li>Descriptions optimisées</li>
            </ul>
            <p>
              <b-icon icon="bolt" size="is-small" type="is-warning" />
              Résultats en moins de 5 minutes
            </p>
            <p class="is-flex">
              <b-dropdown class="mr-3" position="is-top-right">
                <template #trigger>
                  <b-button class="py-6 px-5">
                    {{ quantity.PACK_M }}
                  </b-button>
                </template>
                <b-dropdown-item class="w-280" custom>
                  <b-numberinput
                    type="is-white"
                    min="1"
                    max="10"
                    expanded
                    v-model="quantity.PACK_M"
                  />
                </b-dropdown-item>
              </b-dropdown>
              <b-button
                type="is-primary"
                class="py-6 has-text-black"
                expanded
                @click="buy($constants.AI_PRICE_IDS.PACK_M, quantity.PACK_M)"
              >
                Acheter {{ $constants.AI_PRICES.CREDITS.PACK_M * quantity.PACK_M }} crédits
              </b-button>
            </p>
          </article>
        </div>
      </div>
      <div class="column is-4">
        <div class="aicbcomp_card">
          <figure class="image aicbcomp_scribble aicbcomp_scribble--right">
            <img
              src="@app/assets/img/scribbles/cyan_heart_cute_face.png"
              alt="Pack Pro"
            >
          </figure>
          <article class="box is-white content">
            <header class="flex-between-center">
              <h2 class="title is-5 has-text-black mb-2">
                {{ $constants.AI_PRICES.CREDITS.PACK_L }} crédits

                <span class="is-size-7 has-text-success">
                  + {{ $constants.AI_PRICES.GIFT.PACK_L }} offerts
                </span>
              </h2>
            </header>
            <p>
              <span class="is-size-2 has-text-weight-bold has-text-success">
                {{ $constants.AI_PRICES.PROMO.PACK_L }}&euro;
              </span>
              <span class="is-block is-size-8 has-text-grey-dark">
                Un seul paiement. Tarifs TTC.
              </span>
            </p>
            <p>
              Pour les formateurs ambitieux qui veulent s’appuyer sur nos assistants IA
              pour développer leur activité, créer de nouvelles formations et itérer en toute liberté.
            </p>
            <hr>
            <p class="has-text-weight-bold">
              Accédez à tous les outils :
            </p>
            <ul class="is-size-8">
              <li>Page de vente (rédaction complète)</li>
              <li>Structure pédagogique</li>
              <li>Contenus pédagogiques (générer des leçons multi-média)</li>
              <li>Titres & accroches</li>
              <li>Descriptions optimisées</li>
            </ul>
            <p>
              <b-icon icon="bolt" size="is-small" type="is-warning" />
              Résultats en moins de 5 minutes
            </p>
            <p class="is-flex">
              <b-dropdown class="mr-3" position="is-top-right">
                <template #trigger>
                  <b-button class="py-6 px-5">
                    {{ quantity.PACK_L }}
                  </b-button>
                </template>
                <b-dropdown-item class="w-280" custom>
                  <b-numberinput
                    type="is-white"
                    min="1"
                    max="10"
                    expanded
                    v-model="quantity.PACK_L"
                  />
                </b-dropdown-item>
              </b-dropdown>
              <b-button
                class="py-6"
                expanded
                @click="buy($constants.AI_PRICE_IDS.PACK_L, quantity.PACK_L)"
              >
                Acheter {{ $constants.AI_PRICES.CREDITS.PACK_L * quantity.PACK_L }} crédits
              </b-button>
            </p>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.aicbcomp {
  position: relative;

  &_close {
    position: absolute;
    top: pxToRem(20px);
    right: pxToRem(20px);
  }

  &_card {
    position: relative;
    padding-top: pxToRem(60px);
  }

  &_scribble {
    position: absolute;
    width: pxToRem(120px);
    z-index: 0;
    opacity: 0.7;

    &--left {
      top: pxToRem(-30px);
      left: pxToRem(-60px);
      transform: rotate(-12deg);
    }

    &--center {
      top: pxToRem(-35px);
      left: 50%;
      transform: translateX(-50%) rotate(8deg);
    }

    &--right {
      top: pxToRem(-30px);
      right: pxToRem(-60px);
      left: auto;
      transform: rotate(-6deg);
    }
  }

  &_card .box {
    position: relative;
    z-index: 1;
    padding-top: pxToRem(28px);
  }

  &_badge {
    position: absolute;
    top: pxToRem(-12px);
    right: pxToRem(16px);
    font-weight: bold;
    z-index: 2;
  }
}
</style>
